export default __webpack_public_path__ + "static/screeny-130-gpz-mb-3-e86a0c881b09879bf8aa1ee30fd36299.jpg";